import React from "react";
import "../CSS_stuff/Special_stuff_homepage.css";
import NavMenu from "./Nav_menu"

// Replace these with your real image imports
import Image1 from "../assets/Senili-silver-no-bkgd.png";
import Image2 from "../assets/Cards-with-Farathor-no-bkgd.png";
import Image3 from "../assets/Karana-top-no-bkgd.png";
import Image4 from "../assets/Kefen-only-no-bkgd.png";
import Image5 from "../assets/Ivan-top-no-bkgd.png";

export default function Special_stuff_homepage() {
  const topText = (
    <div className="special-top-text">
      <h2><em>Epic Fantasy with a helping of Sugar and a spoonful of Spice</em></h2>
      {/* <p>
        Put your opening text here. You can use <strong>bold</strong>,
        <em>italics</em>, and normal paragraph text.
      </p> */}
    </div>
  );

  const bottomText = (
    <div className="special-bottom-text">
      <p>
        <em>Meet the Knightess and her Companions<br />
        (both humans & dragons)</em>
      </p>
    </div>
  );

  return (
    <div className="special-homepage-container">
      {topText}

      <div className="special-image-row">
        <div className="special-image-slot">
          { <img src={Image1} alt=" A silver dragon" />}
        </div>
        <div className="special-image-slot">
          {<img src={Image2} alt="A gold dragon flying over Character Cards" />}
        </div>
        <div className="special-image-slot">
          {<img src={Image3} alt="Karana" />}
        </div>
      </div>

      {bottomText}

      <div className="special-image-row">
        <div className="special-image-slot">
          {<img src={Image4} alt="Kefen" />}
        </div>
        <div className="special-text-slot">
          <p>
            Ten thousand years and it all comes down<br />
            to one young woman's choices...<br />
            but WHY CHOOSE?
          </p>
        </div>
        <div className="special-image-slot">
          {<img src={Image5} alt="Ivan" />}
        </div>
      </div>
      <div className="special-bottom-nav">
        <NavMenu showBanner={false} navId="home-bottom-navigation" />
      </div>
    </div>
  );
}